export const ReportTypes = [
  "Raw Material",
  "Component/Parts",
  "Product OEMs",
  "Packaging",
  "Transport & Logistics",
  "Energy & Utility",
  "Service Providers",
  "Construction & Infracstructure",
  "Waste Management",
];
export const ReportStatus = ["Pending", "Accepted", "Rejected"];
